import GenericCallWidget from 'flow/components/call-components/call-widget/GenericCallWidget';
import { buildWidgetDataFromConfig } from 'flow/utils/call-widget-utils';
import PropTypes from 'prop-types';
import React from 'react';

const ConfigurableCallWidget = ({ config, variables, darkMode, width }) => {
    const { header, body, footer, primaryIcon } = buildWidgetDataFromConfig(
        config,
        variables,
    );

    return (
        <GenericCallWidget
            primaryIcon={primaryIcon}
            header={header}
            body={body}
            footer={footer}
            darkMode={darkMode}
            width={width}
        />
    );
};

ConfigurableCallWidget.propTypes = {
    config: PropTypes.shape({
        ...GenericCallWidget.propTypes,
    }),
    variables: PropTypes.object, // eslint-disable-line
    darkMode: PropTypes.bool.isRequired,
    width: PropTypes.number,
};

export default React.memo(ConfigurableCallWidget);
